import Modal from "../components/Modal"
import ToggleSwitch from './ToggleSwitch';
import './theme.css'

const Theme = () => {
  return (
    <Modal className="theme__modal">
        <h3>Choose Theme</h3>
        <ToggleSwitch />
    </Modal>
  )
}

export default Theme